import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { BasketApproval } from 'ish-core/models/basket-approval/basket-approval.model';
import { ModalDialogLinkComponent } from 'ish-shared/components/common/modal-dialog-link/modal-dialog-link.component';

/**
 * Displays the basket approval info (link with modal)
 *
 */
@Component({
  selector: 'ish-basket-approval-info',
  templateUrl: './basket-approval-info.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [FaIconComponent, ModalDialogLinkComponent, NgClass, ServerHtmlDirective, TranslateModule],
})
export class BasketApprovalInfoComponent {
  readonly approval = input.required<BasketApproval>();

  readonly modalComponent = viewChild(ModalDialogLinkComponent);

  /**
   * Callback function to hide modal dialog (used with ishServerHtml). - is needed for closing the dialog after the user clicks a message link
   */
  get callbackHideDialogModal() {
    return () => {
      this.modalComponent().hide();
    };
  }
}
